import { useGetPortalioAuthDetails } from 'src/graphql/entities/integrations/portalio/hooks/use-get-portalio-auth-details';
import { PortalioAuthDetails } from './portalio-auth-details';
import { PortalioConnectIntegration } from './portalio-connect-integration';

export type PortalioAuthResponse = {
  getPortalioUserAuthDetails: {
    authDetails: {
      id: string;
    };
  } | null;
};

export const PortalioIntegrationView = () => {
  const { portalioAuthDetails, loading: portalioLoading } = useGetPortalioAuthDetails();
  const hasPortalioAuthConnection =
    !!portalioAuthDetails && !portalioLoading;

  if (hasPortalioAuthConnection) {
    return (
      <PortalioAuthDetails
        id={portalioAuthDetails.id}
      />
    );
  }

  return <PortalioConnectIntegration />;
};
